
<p>{{ product.product.productName }}</p>
<p>Color: {{ product.product.colorValue }}</p>
<p>Medida: {{ product.product.measurementSystemDetailValue }}</p>
<p *ngIf="showCant">Estado: <p-tag  [severity]="utils.getStatusStyle(product.productStatus!)" value="{{ product.productStatusName }}"></p-tag></p>
<p>{{ showTotalPrice() | currency:'COP':'symbol-narrow':'1.0-0'}}</p>
<p *ngIf="showCant"> Cant: {{ product.cant  }}</p>
<p class="font-bold" style="color: var(--secondary-color)" *ngIf="showCant"> {{ product.product.price * product.cant | currency:'COP':'symbol-narrow':'1.0-0' }}</p>



